import { get } from 'lodash';

import app from '../../scripts/app';

import template from './phone-input.jade';
import './typeahead-popup.tpl.jade';

app.directive('cianAfPhoneInput', [
  '$timeout',
  $timeout => {
    return {
      require: ['cianAfPhoneInput', 'ngModel'],
      template,
      scope: {},
      bindToController: {
        cuiRequired: '=',
        cuiInvalid: '=',
        excludedPhones: '=',
        staticCountryCode: '@?',
      },
      link: (scope, element, attrs, [cianAfPhoneInputCtrl, ngModelCtrl]) => {
        attrs.$observe('disabled', input => {
          cianAfPhoneInputCtrl.disabled = input;
        });

        let codeFocus = false;
        let phoneFocus = false;

        let codeFocusTimeout;
        let phoneFocusTimeout;

        cianAfPhoneInputCtrl.setCodeFocus = (focus = true) => {
          if (codeFocusTimeout) {
            $timeout.cancel(codeFocusTimeout);
          }
          codeFocusTimeout = $timeout(function () {
            codeFocus = focus;
            ngModelCtrl.$focus = codeFocus || phoneFocus;
            if (focus) {
              ngModelCtrl.$setTouched();
            }

            cianAfPhoneInputCtrl.refreshValidators();
          }, 0);
        };

        cianAfPhoneInputCtrl.setPhoneFocus = (focus = true) => {
          if (phoneFocusTimeout) {
            $timeout.cancel(phoneFocusTimeout);
          }
          phoneFocusTimeout = $timeout(function () {
            phoneFocus = focus;
            ngModelCtrl.$focus = codeFocus || phoneFocus;
            if (focus) {
              ngModelCtrl.$setTouched();
              // это нужно только в случае нажатия TAB при открытом дропдауне кодов
              if (!cianAfPhoneInputCtrl.staticCountryCode) {
                cianAfPhoneInputCtrl.dropdownCtrl.close();
              }
            }

            cianAfPhoneInputCtrl.refreshValidators();
          }, 0);
        };

        // prevent input blur on typeahead item click
        cianAfPhoneInputCtrl.phoneMousedown = $event => {
          if ($event.target.tagName !== 'INPUT') {
            $event.preventDefault();
          }
        };

        ngModelCtrl.$isEmpty = value => !(value.countryCode && value.number);
        ngModelCtrl.$parsers.push(viewValue => (!ngModelCtrl.$isEmpty(viewValue) ? { ...viewValue } : null));
        ngModelCtrl.$formatters.push(modelValue =>
          angular.isObject(modelValue) ? { ...modelValue } : { ...cianAfPhoneInputCtrl.defaultPhone },
        );
        ngModelCtrl.$validators.phoneNumberParse = () => {
          return !get(cianAfPhoneInputCtrl.phoneForm, '$error.pattern');
        };

        ngModelCtrl.$validators.phoneNumberMask = () => {
          return !get(cianAfPhoneInputCtrl.phoneForm, '$error.mask');
        };

        ngModelCtrl.$render = () => {
          ngModelCtrl.$setViewValue(Object.assign(cianAfPhoneInputCtrl.phone, ngModelCtrl.$viewValue));
        };

        cianAfPhoneInputCtrl.refreshValidators = () => {
          ngModelCtrl.$validate();
        };

        scope.$watch(
          () => cianAfPhoneInputCtrl.phone,
          newValue => {
            ngModelCtrl.$setViewValue({ ...newValue });
          },
          true,
        );
      },
      controller: [
        'countryCodes',
        'userService',
        function (countryCodes, userService) {
          const codeGetHtml = code => `
        <div class='phone-input__dropdown-country'>${code.countryName}</div>
        <div class='phone-input__dropdown-code'>${code.countryPhoneCode}</div>
      `;

          this.phoneCodeTerms = countryCodes
            .filter(code => code.countryPhoneCode) // Отфильтровываем страны, у которых не указан код
            .map(code => ({
              ...code,
              html: codeGetHtml(code),
            }));

          this.phone = {
            number: '',
          };

          if (!this.staticCountryCode) {
            this.phone.countryCode = this.phoneCodeTerms[0].countryPhoneCode;
          }

          this.defaultPhone = { ...this.phone };

          const isExcluded = phoneNumber => {
            return (
              this.excludedPhones &&
              this.excludedPhones.some(excludedPhoneNumber => {
                return (
                  angular.isObject(excludedPhoneNumber) &&
                  excludedPhoneNumber.countryCode === phoneNumber.countryCode &&
                  excludedPhoneNumber.number === phoneNumber.number
                );
              })
            );
          };

          this.getPhonesSuggest = (rawTerm = '') => {
            const term = rawTerm.replace(/\D/g, '');
            if (
              userService.isAuthenticated &&
              userService.user &&
              userService.user.phoneNumbers &&
              Array.isArray(userService.user.phoneNumbers)
            ) {
              return userService.user.phoneNumbers
                .filter(phoneNumber => {
                  return (
                    phoneNumber.countryCode === this.phone.countryCode &&
                    phoneNumber.number.includes(term) &&
                    !isExcluded(phoneNumber)
                  );
                })
                .map(phoneNumber => phoneNumber.number);
            }
          };

          this.isCodeRussian = () => this.phone.countryCode === '+7';
        },
      ],
      controllerAs: 'phoneInputCtrl',
      replace: true,
    };
  },
]);

app.directive('cianAfUiMaskViewToModel', [
  '$timeout',
  function ($timeout) {
    return {
      require: 'ngModel',
      link: (scope, element) => {
        let prevElementValue = element.val();
        element.on('keydown', () => {
          if (element.val() !== prevElementValue) {
            prevElementValue = element.val();
            $timeout(() => {
              // $viewValue updated after keydown, wait for it
              element.triggerHandler('blur'); // Чтобы ui-mask записала значение в модель, иначе она ждет до блюра = моргает сообщение валидации
              element.triggerHandler('focus'); // Возвращаем состояние фокуса, что бы не показывалась сообщение валидации
            }, 0);
          }
        });
      },
    };
  },
]);

app.directive('cianAfSetDropdownCtrl', [
  function () {
    return {
      require: 'cianUiDropdown',
      link: (scope, element, attrs, cianUiDropdownCtrl) => {
        scope.phoneInputCtrl.dropdownCtrl = cianUiDropdownCtrl;
      },
    };
  },
]);
